import {AdminsListState} from './states/admins-list.state';

export const adminsState = [
    AdminsListState
];
